/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { useScene } from '@/lib/useCommon';
import style from './index.module.less';

function AIChangeCard() {
  const { sceneConfigMap, scene } = useSelector((state: RootState) => state.room);
  const { icon, isVision } = useScene();
  const currentScene = sceneConfigMap?.[scene]?.name || '默认场景';

  return (
    <div className={style.card}>
      <div className={style.avatar}>
        <img id="avatar-card" src={icon} alt="Avatar" />
      </div>
      <div className={style.title}>
        <div>Hi，欢迎体验实时对话式 AI</div>
        <div className={style.desc}>
          {isVision ? <>支持豆包 Vision 模型和 深度思考模型，</> : ''}
          点击右上角齿轮可切换场景和设备
        </div>
      </div>
      <div className={style.currentScene}>当前场景：{currentScene}</div>
    </div>
  );
}

export default AIChangeCard;
